// extracted by mini-css-extract-plugin
export var close = "index-module--close--23Qsv";
export var videoContainer = "index-module--videoContainer--l-gwS";
export var videoWrap = "index-module--videoWrap--UQw+E";